import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Hero from '@/pages/home/components/Hero';
import Cards from '@/pages/home/components/Cards';
import Updates from '@/pages/home/components/Updates';
import AppEntry from '@/pages/home/components/AppEntry';
import Contact from '@/pages/home/components/Contact';
import Ranking from '@/pages/home/components/Ranking';
import FAQ from '@/pages/home/components/FAQ';
import Features from '@/pages/home/components/Features';
import About from '@/pages/home/components/About';
import Carousel from '@/pages/home/components/Carousel';
import Comments from '@/pages/home/components/Comments';
import Index from '@/pages/home/components/Index';
import Topics from '@/pages/home/components/Topics';
import Media from '@/pages/home/components/Media';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Cards />
        <Updates />
        <AppEntry />
        <Contact />
        <Ranking />
        <FAQ />
        <Features />
        <About />
        <Carousel />
        <Comments />
        <Index />
        <Topics />
        <Media />
      </main>
      <Footer />
    </>
  );
}